import React from 'react';
import { Alert, Box, CircularProgress, Stack, Typography } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

export default function AsyncState({
  state,
  title,
  message,
  action,
  minHeight = 220,
  fullWidth = false,
}) {
  if (state === 'loading') {
    return (
      <Box
        sx={{
          minHeight,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: fullWidth ? '100%' : 'auto',
        }}
      >
        <Stack spacing={2} alignItems="center">
          <CircularProgress />
          {message ? <Typography color="text.secondary">{message}</Typography> : null}
        </Stack>
      </Box>
    );
  }

  if (state === 'error') {
    return (
      <Alert severity="error" action={action} sx={{ width: fullWidth ? '100%' : 'auto' }}>
        {title ? <Typography variant="subtitle2" fontWeight={700} gutterBottom>{title}</Typography> : null}
        <Typography variant="body2">{message}</Typography>
      </Alert>
    );
  }

  if (state === 'empty') {
    return (
      <Box
        sx={{
          minHeight,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: fullWidth ? '100%' : 'auto',
          border: '1px dashed',
          borderColor: 'divider',
          borderRadius: (theme) => theme.radius.base,
          bgcolor: 'background.muted',
          px: 3,
        }}
      >
        <Stack spacing={1.5} alignItems="center" textAlign="center">
          <InboxOutlinedIcon color="disabled" />
          {title ? <Typography variant="h6">{title}</Typography> : null}
          {message ? <Typography variant="body2" color="text.secondary">{message}</Typography> : null}
          {action || null}
        </Stack>
      </Box>
    );
  }

  return null;
}